/**
 * 用户API
 * 用户API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The LoginSuccessDto model module.
   * @module user/model/LoginSuccessDto
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>LoginSuccessDto</code>.
   * @alias module:user/model/LoginSuccessDto
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>LoginSuccessDto</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:user/model/LoginSuccessDto} obj Optional instance to populate.
   * @return {module:user/model/LoginSuccessDto} The populated <code>LoginSuccessDto</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('xiaoquId')) {
        obj['xiaoquId'] = ApiClient.convertToType(data['xiaoquId'], 'Integer');
      }
      if (data.hasOwnProperty('xiaoqu')) {
        obj['xiaoqu'] = ApiClient.convertToType(data['xiaoqu'], 'String');
      }
      if (data.hasOwnProperty('loudongId')) {
        obj['loudongId'] = ApiClient.convertToType(data['loudongId'], 'Integer');
      }
      if (data.hasOwnProperty('loudong')) {
        obj['loudong'] = ApiClient.convertToType(data['loudong'], 'String');
      }
      if (data.hasOwnProperty('roomId')) {
        obj['roomId'] = ApiClient.convertToType(data['roomId'], 'Integer');
      }
      if (data.hasOwnProperty('room')) {
        obj['room'] = ApiClient.convertToType(data['room'], 'String');
      }
      if (data.hasOwnProperty('usedAmp')) {
        obj['usedAmp'] = ApiClient.convertToType(data['usedAmp'], 'Number');
      }
      if (data.hasOwnProperty('allAmp')) {
        obj['allAmp'] = ApiClient.convertToType(data['allAmp'], 'Number');
      }
    }
    return obj;
  }

  /**
   * 用户id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 姓名
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 校区id
   * @member {Integer} xiaoquId
   */
  exports.prototype['xiaoquId'] = undefined;
  /**
   * 校区
   * @member {String} xiaoqu
   */
  exports.prototype['xiaoqu'] = undefined;
  /**
   * 楼栋id
   * @member {Integer} loudongId
   */
  exports.prototype['loudongId'] = undefined;
  /**
   * 楼栋
   * @member {String} loudong
   */
  exports.prototype['loudong'] = undefined;
  /**
   * 寝室id
   * @member {Integer} roomId
   */
  exports.prototype['roomId'] = undefined;
  /**
   * 寝室
   * @member {String} room
   */
  exports.prototype['room'] = undefined;
  /**
   * 寝室
   * @member {Number} usedAmp
   */
  exports.prototype['usedAmp'] = undefined;
  /**
   * 寝室
   * @member {Number} allAmp
   */
  exports.prototype['allAmp'] = undefined;



  export default exports;
;


